<template>
  <div class="list-info banxin content">
    <Information :url="data.img" :title="data.title" :api="''" :id="data.cateid"/>
  </div>
</template>
<script>
import Information from '@/components/Information3'
export default {
  props: ['data'],
  components: { Information },
  data() {
    return {

    }
  },
  methods: {
    
  },
  mounted() {
  }
}
</script>

<style lang="less" scoped>

</style>